import GasSafetyRecord from './GasSafetyRecord';
import ElectricalCertificate from './ElectricalCertificate';
import DomesticGasSafety from './DomesticGasSafety';
import OilFiringInstallation from './OilFiringInstallation';
import UnventedHotWaterStorageVesselCommissioningInspection from './UnventedHotWaterStorageVesselCommissioningInspection';
import AirSourceHeatPumpHotWaterCylinderServiceMaintenance from './AirSourceHeatPumpHotWaterCylinderServiceMaintenance';
import ElectricalInstallationCertificate from './ElectricalInstallationCertificate';
import ElectricalConditionReport from './ElectricalConditionReport';
import MinorElectricalWorks from './MinorElectricalWorks';
import PortableApplianceTesting from './PortableApplianceTesting';
import AirToWaterHeatPumpCommissioning from './AirToWaterHeatPumpCommissioning';
import GroundSourceHeatPumpServiceMaintenance from './GroundSourceHeatPumpServiceMaintenance';
import CentralHeatingPowerflushCertificate from './CentralHeatingPowerflushCertificate';
import TmvMaintenanceChecklist from './TmvMaintenanceChecklist';
import ChpCommissioningServicingRecord from './ChpCommissioningServicingRecord';
import MobileCateringGasSafetyRecord from './MobileCateringGasSafetyRecord';
import CaravanBoatLpgSafetyRecord from './CaravanBoatLpgSafetyRecord';
import InstallationCommissioningDecommissioning from './InstallationCommissioningDecommissioning';
import OftecCd11ServicingCommissioning from './OftecCd11ServicingCommissioning';

// Debug: Check what's actually exported
if (process.env.NODE_ENV === 'development') {
  console.log('🔍 GasSafetyRecord exports:', Object.keys(GasSafetyRecord));
  console.log('🔍 ElectricalCertificate exports:', Object.keys(ElectricalCertificate));
}

export const formRegistry = {
  'gas-safety-record': {
    id: 'gas-safety-record',
    name: 'Gas Safety Record',
    description: 'Landlord/Homeowner Gas Safety Record (CP12)',
    category: 'Gas Safety',
    icon: '🔥',
    version: '1.0.0',
    component: GasSafetyRecord.Form,
    pdfComponent: GasSafetyRecord.PDF,
    schema: GasSafetyRecord.schema,
    validator: GasSafetyRecord.validator,
    defaultData: GasSafetyRecord.defaultData,
    transformForPDF: GasSafetyRecord.transform,
    templates: GasSafetyRecord.templates
  },
  'domestic-gas-safety': {
    id: 'domestic-gas-safety',
    name: 'Domestic Gas Safety Record',
    description: 'CP12 Landlord Gas Safety Record',
    category: 'Gas Safety',
    icon: '🔥',
    version: '1.0.0',
    component: DomesticGasSafety.Form,
    pdfComponent: DomesticGasSafety.PDF,
    schema: DomesticGasSafety.schema,
    validator: DomesticGasSafety.validator,
    defaultData: DomesticGasSafety.defaultData,
    transformForPDF: DomesticGasSafety.transform,
    templates: DomesticGasSafety.templates
  },
  'electrical-certificate': {
    id: 'electrical-certificate',
    name: 'Electrical Certificate',
    description: 'Electrical Installation Condition Report',
    category: 'Electrical',
    icon: '⚡',
    version: '1.0.0',
    component: ElectricalCertificate.Form,
    pdfComponent: ElectricalCertificate.PDF,
    schema: ElectricalCertificate.schema,
    validator: ElectricalCertificate.validator,
    defaultData: ElectricalCertificate.defaultData,
    transformForPDF: ElectricalCertificate.transform,
    templates: ElectricalCertificate.templates
  },
  'oil-firing-installation': {
    id: 'oil-firing-installation',
    name: 'Oil Firing Installation Completion Report',
    description: 'OFTEC Installation Report',
    category: 'Oil',
    icon: '🛢️',
    version: '1.0.0',
    component: OilFiringInstallation.Form,
    pdfComponent: OilFiringInstallation.PDF,
    schema: OilFiringInstallation.schema,
    validator: OilFiringInstallation.validator,
    defaultData: OilFiringInstallation.defaultData,
    transformForPDF: OilFiringInstallation.transform
  },
  'unvented-hot-water-storage-vessel-commissioning-inspection': {
    id: 'unvented-hot-water-storage-vessel-commissioning-inspection',
    name: 'Unvented Hot Water Storage Vessel Commissioning Inspection Report',
    description: 'Building Regulations Approved Document G3 Unvented Cylinder Commissioning & Inspection',
    category: 'Plumbing',
    icon: '💧',
    version: '1.0.0',
    component: UnventedHotWaterStorageVesselCommissioningInspection.Form,
    pdfComponent: UnventedHotWaterStorageVesselCommissioningInspection.PDF,
    schema: UnventedHotWaterStorageVesselCommissioningInspection.schema,
    validator: UnventedHotWaterStorageVesselCommissioningInspection.validator,
    defaultData: UnventedHotWaterStorageVesselCommissioningInspection.defaultData,
    transformForPDF: UnventedHotWaterStorageVesselCommissioningInspection.transform
  },
  'air-source-heat-pump-hot-water-cylinder-service-maintenance': {
    id: 'air-source-heat-pump-hot-water-cylinder-service-maintenance',
    name: 'Air Source Heat Pump & Hot Water Cylinder Service/Maintenance Checklist',
    description: 'Periodic maintenance and inspection checklist for air source heat pumps and unvented cylinders',
    category: 'HVAC / Renewables',
    icon: '♨️',
    version: '1.0.0',
    component: AirSourceHeatPumpHotWaterCylinderServiceMaintenance.Form,
    pdfComponent: AirSourceHeatPumpHotWaterCylinderServiceMaintenance.PDF,
    schema: AirSourceHeatPumpHotWaterCylinderServiceMaintenance.schema,
    validator: AirSourceHeatPumpHotWaterCylinderServiceMaintenance.validator,
    defaultData: AirSourceHeatPumpHotWaterCylinderServiceMaintenance.defaultData,
    transformForPDF: AirSourceHeatPumpHotWaterCylinderServiceMaintenance.transform
  },
  'electrical-installation-certificate': {
    id: 'electrical-installation-certificate',
    name: 'Electrical Installation Certificate (EIC)',
    description: 'BS 7671:2018+A2:2022 Electrical Installation Certificate',
    category: 'Electrical',
    icon: '⚡',
    version: '1.0.0',
    component: ElectricalInstallationCertificate.Form,
    pdfComponent: ElectricalInstallationCertificate.PDF,
    schema: ElectricalInstallationCertificate.schema,
    validator: ElectricalInstallationCertificate.validator,
    defaultData: ElectricalInstallationCertificate.defaultData,
    transformForPDF: ElectricalInstallationCertificate.transform
  },
  'electrical-condition-report': {
    id: 'electrical-condition-report',
    name: 'Electrical Installation Condition Report (EICR)',
    description: 'BS 7671:2018+A2:2022 periodic inspection & testing with C1/C2/C3/FI observations',
    category: 'Electrical',
    icon: '⚡',
    version: '1.0.0',
    component: ElectricalConditionReport.Form,
    pdfComponent: ElectricalConditionReport.PDF,
    schema: ElectricalConditionReport.schema,
    validator: ElectricalConditionReport.validator,
    defaultData: ElectricalConditionReport.defaultData,
    transformForPDF: ElectricalConditionReport.transform
  },
  'minor-electrical-works': {
    id: 'minor-electrical-works',
    name: 'Minor Electrical Installation Works Certificate (MEIWC)',
    description: 'BS 7671:2018+A2:2022 minor electrical works - additions, alterations and replacements',
    category: 'Electrical',
    icon: '⚡',
    version: '1.0.0',
    component: MinorElectricalWorks.Form,
    pdfComponent: MinorElectricalWorks.PDF,
    schema: MinorElectricalWorks.schema,
    validator: MinorElectricalWorks.validator,
    defaultData: MinorElectricalWorks.defaultData,
    transformForPDF: MinorElectricalWorks.transform,
    buildVerificationPayload: MinorElectricalWorks.buildVerificationPayload
  },
  'portable-appliance-testing': {
    id: 'portable-appliance-testing',
    name: 'Portable Appliance Testing (PAT) Certificate & Register',
    description: 'IET Code of Practice in-service inspection and testing with auto pass/fail evaluation',
    category: 'Electrical',
    icon: '🔌',
    version: '1.0.0',
    component: PortableApplianceTesting.Form,
    pdfComponent: PortableApplianceTesting.PDF,
    schema: PortableApplianceTesting.schema,
    validator: PortableApplianceTesting.validator,
    defaultData: PortableApplianceTesting.defaultData,
    transformForPDF: PortableApplianceTesting.transform,
    buildVerificationPayload: PortableApplianceTesting.buildVerificationPayload
  },
  'air-to-water-heat-pump-commissioning': {
    id: 'air-to-water-heat-pump-commissioning',
    name: 'Air-to-Water Heat Pump Commissioning Checklist (MCS MIS 3005)',
    description: 'MCS MIS 3005 compliant handover checklist and design delta T commissioning record',
    category: 'HVAC / Renewables',
    icon: '❄️',
    version: '1.0.0',
    component: AirToWaterHeatPumpCommissioning.Form,
    pdfComponent: AirToWaterHeatPumpCommissioning.PDF,
    schema: AirToWaterHeatPumpCommissioning.schema,
    validator: AirToWaterHeatPumpCommissioning.validator,
    defaultData: AirToWaterHeatPumpCommissioning.defaultData,
    transformForPDF: AirToWaterHeatPumpCommissioning.transform
  },
  'ground-source-heat-pump-service-maintenance': {
    id: 'ground-source-heat-pump-service-maintenance',
    name: 'Ground Source Heat Pump & Cylinder Service Checklist',
    description: 'Ground loop brine circuit and unvented hot water cylinder periodic maintenance record',
    category: 'HVAC / Renewables',
    icon: '🌱',
    version: '1.0.0',
    component: GroundSourceHeatPumpServiceMaintenance.Form,
    pdfComponent: GroundSourceHeatPumpServiceMaintenance.PDF,
    schema: GroundSourceHeatPumpServiceMaintenance.schema,
    validator: GroundSourceHeatPumpServiceMaintenance.validator,
    defaultData: GroundSourceHeatPumpServiceMaintenance.defaultData,
    transformForPDF: GroundSourceHeatPumpServiceMaintenance.transform
  },
  'central-heating-powerflush-certificate': {
    id: 'central-heating-powerflush-certificate',
    name: 'Central Heating Powerflush Certificate (BS 7593)',
    description: 'BS 7593:2019 water quality, chemical cleaning and inhibitor protection record',
    category: 'Plumbing',
    icon: '🚿',
    version: '1.0.0',
    component: CentralHeatingPowerflushCertificate.Form,
    pdfComponent: CentralHeatingPowerflushCertificate.PDF,
    schema: CentralHeatingPowerflushCertificate.schema,
    validator: CentralHeatingPowerflushCertificate.validator,
    defaultData: CentralHeatingPowerflushCertificate.defaultData,
    transformForPDF: CentralHeatingPowerflushCertificate.transform
  },
  'tmv-maintenance-checklist': {
    id: 'tmv-maintenance-checklist',
    name: 'Thermostatic Mixing Valve (TMV) Maintenance Checklist',
    description: 'TMV2 / TMV3 Scheme (NHS D08) commissioning and fail-safe shut-off compliance record',
    category: 'Plumbing',
    icon: '🌡️',
    version: '1.0.0',
    component: TmvMaintenanceChecklist.Form,
    pdfComponent: TmvMaintenanceChecklist.PDF,
    schema: TmvMaintenanceChecklist.schema,
    validator: TmvMaintenanceChecklist.validator,
    defaultData: TmvMaintenanceChecklist.defaultData,
    transformForPDF: TmvMaintenanceChecklist.transform
  },
  'chp-commissioning-servicing-record': {
    id: 'chp-commissioning-servicing-record',
    name: 'Combined Heat & Power (CHP) Commissioning & Servicing Record',
    description: 'Commercial cogeneration commissioning, ENA EREC G99 grid interface and servicing record',
    category: 'HVAC / Renewables',
    icon: '⚙️',
    version: '1.0.0',
    component: ChpCommissioningServicingRecord.Form,
    pdfComponent: ChpCommissioningServicingRecord.PDF,
    schema: ChpCommissioningServicingRecord.schema,
    validator: ChpCommissioningServicingRecord.validator,
    defaultData: ChpCommissioningServicingRecord.defaultData,
    transformForPDF: ChpCommissioningServicingRecord.transform
  },
  'mobile-catering-gas-safety-record': {
    id: 'mobile-catering-gas-safety-record',
    name: 'Mobile Catering Vehicle / Trailer Gas Safety Record',
    description: 'UKLPG Code of Practice 24 & BS 6173 catering trailer and food truck safety certificate',
    category: 'Gas Safety',
    icon: '🚚',
    version: '1.0.0',
    component: MobileCateringGasSafetyRecord.Form,
    pdfComponent: MobileCateringGasSafetyRecord.PDF,
    schema: MobileCateringGasSafetyRecord.schema,
    validator: MobileCateringGasSafetyRecord.validator,
    defaultData: MobileCateringGasSafetyRecord.defaultData,
    transformForPDF: MobileCateringGasSafetyRecord.transform
  },
  'caravan-boat-lpg-safety-record': {
    id: 'caravan-boat-lpg-safety-record',
    name: 'Caravan & Marine Boat LPG Gas Safety Record',
    description: 'BS EN ISO 10239 (Marine) & BS EN 1949 (Caravans) Boat Safety Scheme (BSS) record',
    category: 'Gas Safety',
    icon: '⛵',
    version: '1.0.0',
    component: CaravanBoatLpgSafetyRecord.Form,
    pdfComponent: CaravanBoatLpgSafetyRecord.PDF,
    schema: CaravanBoatLpgSafetyRecord.schema,
    validator: CaravanBoatLpgSafetyRecord.validator,
    defaultData: CaravanBoatLpgSafetyRecord.defaultData,
    transformForPDF: CaravanBoatLpgSafetyRecord.transform
  },
  'installation-commissioning-decommissioning': {
    id: 'installation-commissioning-decommissioning',
    name: 'General Installation, Commissioning & Decommissioning Record',
    description: 'Multi-trade plant handover, safe isolation, F-Gas recovery and decommissioning record',
    category: 'Plumbing',
    icon: '🛠️',
    version: '1.0.0',
    component: InstallationCommissioningDecommissioning.Form,
    pdfComponent: InstallationCommissioningDecommissioning.PDF,
    schema: InstallationCommissioningDecommissioning.schema,
    validator: InstallationCommissioningDecommissioning.validator,
    defaultData: InstallationCommissioningDecommissioning.defaultData,
    transformForPDF: InstallationCommissioningDecommissioning.transform
  },
  'oftec-cd11-servicing-commissioning': {
    id: 'oftec-cd11-servicing-commissioning',
    name: 'OFTEC CD/11 Oil Firing Servicing & Commissioning Report',
    description: 'OFTEC CD/11 servicing, nozzle/pump tuning and combustion test certificate',
    category: 'Oil',
    icon: '🛢️',
    version: '1.0.0',
    component: OftecCd11ServicingCommissioning.Form,
    pdfComponent: OftecCd11ServicingCommissioning.PDF,
    schema: OftecCd11ServicingCommissioning.schema,
    validator: OftecCd11ServicingCommissioning.validator,
    defaultData: OftecCd11ServicingCommissioning.defaultData,
    transformForPDF: OftecCd11ServicingCommissioning.transform
  }
};

// Helper functions with error handling
export const getFormConfig = (formId) => {
  const config = formRegistry[formId];
  if (!config) {
    console.warn(`❌ Form "${formId}" not found in registry!`);
  }
  return config;
};

export const getAllForms = () => {
  return Object.values(formRegistry);
};

export const getFormCategories = () => {
  return [...new Set(Object.values(formRegistry).map(form => form.category))];
};
